// @flow

export const HELP =
  process.env.CATALYTIC_HELP_URL || 'https://help.catalytic.com/';
